var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mentor (Messages)",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-1153 -215)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-33 -142H287V175H-33V-142Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-33 175H-34V176H-33V175ZM287 174H-33V176H287V174ZM-32 175V-142H-34V175H-32Z",
    fill: "#E0E0E0",
    mask: "url(#path-1-inside-1_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 163167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 163166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 162844"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 12,
    cy: 12,
    r: 20,
    fill: "white",
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vscode-icons:file-type-powerpoint"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1976 12.975L12.7328 2.25H12.6233C10.0662 2.25434 7.61477 3.27086 5.80491 5.07735C3.99505 6.88384 2.97396 9.33337 2.96484 11.8905V12L14.1976 12.975Z",
    fill: "#ED6C47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8419 2.25H12.7324V12L17.6157 13.95L22.4997 12V11.8905C22.4906 9.3335 21.4696 6.88408 19.6599 5.07761C17.8502 3.27115 15.3989 2.25454 12.8419 2.25Z",
    fill: "#FF8F6B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.5001 12V12.1072C22.4906 14.6647 21.4692 17.1145 19.6592 18.9213C17.8492 20.7281 15.3976 21.7451 12.8401 21.75H12.6248C10.0675 21.7447 7.61612 20.7276 5.80617 18.9209C3.99622 17.1141 2.97475 14.6646 2.96484 12.1072V12H22.5001Z",
    fill: "#D35230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.1,
    d: "M13.2211 7.04165V17.4449C13.2197 17.6219 13.1662 17.7946 13.0672 17.9413C12.9683 18.0881 12.8282 18.2024 12.6646 18.2699C12.5578 18.3149 12.443 18.3381 12.3271 18.3382H5.27035C5.13344 18.1811 5.00308 18.0185 4.8796 17.8507C3.63557 16.1946 2.96355 14.1791 2.96485 12.1079V11.8934C2.96249 10.0251 3.50942 8.19733 4.5376 6.6374C4.64423 6.46985 4.75834 6.30719 4.8796 6.1499H12.3271C12.5633 6.15147 12.7895 6.24585 12.9567 6.41269C13.124 6.57952 13.2189 6.80543 13.2211 7.04165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M12.7328 7.53019V17.9334C12.7328 18.0489 12.7096 18.1631 12.6646 18.2694C12.5969 18.4329 12.4826 18.5728 12.3359 18.6717C12.1891 18.7705 12.0165 18.8239 11.8396 18.8252H5.7151C5.5606 18.6682 5.41235 18.5057 5.27035 18.3377C5.13344 18.1806 5.00308 18.018 4.8796 17.8502C3.63556 16.1942 2.96355 14.1787 2.96485 12.1074V11.8929C2.96264 10.0249 3.50956 8.19741 4.5376 6.6377H11.8388C12.0752 6.63926 12.3015 6.73375 12.4687 6.90074C12.636 7.06774 12.7309 7.29384 12.7328 7.53019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M12.7328 7.5302V16.9584C12.7307 17.1947 12.6357 17.4206 12.4685 17.5874C12.3012 17.7542 12.0751 17.8486 11.8388 17.8502H4.8796C3.63556 16.1942 2.96355 14.1787 2.96485 12.1074V11.8929C2.96264 10.0249 3.50956 8.19741 4.5376 6.6377H11.8388C12.0752 6.63926 12.3015 6.73375 12.4687 6.90074C12.636 7.06774 12.7309 7.29384 12.7328 7.5302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M12.2446 7.5302V16.9584C12.2424 17.1947 12.1475 17.4206 11.9802 17.5874C11.813 17.7542 11.5868 17.8486 11.3506 17.8502H4.8796C3.63556 16.1942 2.96355 14.1787 2.96485 12.1074V11.8929C2.96264 10.0249 3.50956 8.19741 4.5376 6.6377H11.3506C11.587 6.63926 11.8132 6.73375 11.9805 6.90074C12.1478 7.06774 12.2426 7.29384 12.2446 7.5302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.3955 6.6377H11.349C11.5862 6.6375 11.8137 6.73147 11.9816 6.89897C12.1496 7.06646 12.2441 7.29377 12.2445 7.53095V16.4694C12.2441 16.7066 12.1496 16.9339 11.9816 17.1014C11.8137 17.2689 11.5862 17.3629 11.349 17.3627H2.3955C2.27804 17.3629 2.16168 17.3399 2.05309 17.2951C1.9445 17.2504 1.84581 17.1846 1.76264 17.1016C1.67948 17.0187 1.61348 16.9202 1.56841 16.8117C1.52334 16.7032 1.5001 16.5869 1.5 16.4694V7.53095C1.5001 7.41348 1.52334 7.29719 1.56841 7.18871C1.61348 7.08023 1.67948 6.9817 1.76264 6.89875C1.84581 6.81579 1.9445 6.75004 2.05309 6.70525C2.16168 6.66045 2.27804 6.6375 2.3955 6.6377Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M6.96947 9.02119C7.55232 8.98198 8.13015 9.15103 8.59997 9.49819C8.79315 9.67015 8.94461 9.88387 9.04285 10.1231C9.1411 10.3624 9.18354 10.6208 9.16697 10.8789C9.17353 11.2425 9.0765 11.6004 8.88722 11.9109C8.69572 12.2165 8.41987 12.46 8.09297 12.6122C7.71946 12.7854 7.31135 12.8711 6.89972 12.8627H5.76497V14.9627H4.60547V9.02119H6.96947ZM5.76422 11.9552H6.76247C7.07897 11.978 7.39291 11.8844 7.64522 11.6919C7.74839 11.5935 7.82873 11.4737 7.88056 11.3409C7.93239 11.208 7.95446 11.0655 7.94522 10.9232C7.94522 10.2687 7.56397 9.94119 6.80147 9.94069H5.76422V11.9552Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 3.3705,
    y1: 5.9357,
    x2: 10.374,
    y2: 18.0647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA4C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C5401E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62F14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-1153 -215)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.18ccac908844870d8ec00220af13e562.svg";
export { ForwardRef as ReactComponent };